import { isGroupLike, isMindMap, isMindMapLeaf } from '../objects/guards';

/**
 * Sets the `useTheme` flag on MindMap or MindMapLeaf, going recursively if the object is a group/selection.
 * Ignores any objects that aren't MindMap or MindMapLeaf
 * @param obj Fabric object that is either a MindMap, MindMapLeaf, or a group/selection containing those
 * @param enabled Value to set `useTheme` to.
 */
export function enableLeafTheme(
  obj: fabric.Object,
  enabled: boolean,
  redrawToolbar?: boolean
) {
  if (isGroupLike(obj)) {
    obj._objects.map(o => enableLeafTheme(o, enabled, redrawToolbar));
  } else if (isMindMapLeaf(obj)) {
    obj.set('useTheme', enabled);
    if (enabled) {
      obj.getMindMap()!.applyLeafTheme(obj);
    }
    if (enabled || redrawToolbar) {
      obj.controller.actionRerenderToolbar();
    }
  } else if (isMindMap(obj)) {
    obj.set('useTheme', enabled);
    if (enabled) {
      obj.applyRootTheme();
    }
    if (enabled || redrawToolbar) {
      obj.controller.actionRerenderToolbar();
    }
  }
}
